
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import OpenOpportunities from './components/OpenOpportunities';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <OpenOpportunities />
        <AboutSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
